module.exports = __webpack_public_path__ + "static/firemniPoradenstvi-46b874cc9bd965250c03824f90a304e0.png";